<div class="layout-topbar">
    <div class="topbar-left">
        <a routerLink="/" class="flex items-center">
            <img src="assets/images/logo.png" alt="Logo" class="h-10 object-contain"
                 onerror="this.style.display='none'; this.nextElementSibling.style.display='block'" />
            <span class="hidden text-2xl font-bold text-surface-950 dark:text-surface-0" style="font-family: 'InterDisplay', sans-serif;">tessi</span>
        </a>
    </div>

    <div class="topbar-right">
        <ul class="topbar-menu">
            <li class="profile-item static sm:relative">
                <a class="right-sidebar-button relative z-50 flex items-center gap-3" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                    <span class="label-small text-surface-600 dark:text-surface-300 hidden sm:inline">{{ displayName }}</span>
                    <p-avatar [label]="initials" styleClass="w-10! h-10!" shape="circle" />
                </a>
                <div
                    class="list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-900 hidden origin-top w-52 mt-2 right-0 z-999 top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
                >
                    <ul class="flex flex-col gap-1">
                        <li>
                            <a (click)="onLogout()" class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer">
                                <i class="pi pi-power-off"></i>
                                <span>{{ 'layout.topbar.logout' | translate }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</div>
